// Auto-generated from processed gallery. Do not edit by hand.
// Regenerate via /tmp/process_gallery.py if new photos are added.
export const galleryImages = [
  {
    id: 1,
    thumb: "/gallery/thumbs/k001.webp",
    full: "/gallery/full/k001.webp",
    caption: "Administering laser therapy treatment",
  },
  {
    id: 2,
    thumb: "/gallery/thumbs/k002.webp",
    full: "/gallery/full/k002.webp",
    caption: "Performing targeted laser therapy",
  },
  {
    id: 3,
    thumb: "/gallery/thumbs/k003.webp",
    full: "/gallery/full/k003.webp",
    caption: "Initial patient consultation session",
  },
  {
    id: 4,
    thumb: "/gallery/thumbs/k004.webp",
    full: "/gallery/full/k004.webp",
    caption: "Initial patient consultation session",
  },
  {
    id: 5,
    thumb: "/gallery/thumbs/k005.webp",
    full: "/gallery/full/k005.webp",
    caption: "Explaining cranial anatomy with a model",
  },
  {
    id: 6,
    thumb: "/gallery/thumbs/k006.webp",
    full: "/gallery/full/k006.webp",
    caption: "Krina drawing on whiteboard",
  },
  {
    id: 7,
    thumb: "/gallery/thumbs/k007.webp",
    full: "/gallery/full/k007.webp",
    caption: "Displaying a jaw anatomical model",
  },
  {
    id: 8,
    thumb: "/gallery/thumbs/k008.webp",
    full: "/gallery/full/k008.webp",
    caption: "Krina holding skull model",
  },
  {
    id: 9,
    thumb: "/gallery/thumbs/k009.webp",
    full: "/gallery/full/k009.webp",
    caption: "Krina explaining joint movement",
  },
  {
    id: 10,
    thumb: "/gallery/thumbs/k010.webp",
    full: "/gallery/full/k010.webp",
    caption: "Performing a patient examination",
  },
  {
    id: 11,
    thumb: "/gallery/thumbs/k011.webp",
    full: "/gallery/full/k011.webp",
    caption: "Capturing posture with a device",
  },
  {
    id: 12,
    thumb: "/gallery/thumbs/k012.webp",
    full: "/gallery/full/k012.webp",
    caption: "Assessing jaw mobility",
  },
  {
    id: 13,
    thumb: "/gallery/thumbs/k013.webp",
    full: "/gallery/full/k013.webp",
    caption: "Measuring range of jaw opening",
  },
  {
    id: 14,
    thumb: "/gallery/thumbs/k014.webp",
    full: "/gallery/full/k014.webp",
    caption: "Assessing jaw range of motion",
  },
  {
    id: 15,
    thumb: "/gallery/thumbs/k015.webp",
    full: "/gallery/full/k015.webp",
    caption: "Assessing jaw mobility",
  },
  {
    id: 16,
    thumb: "/gallery/thumbs/k016.webp",
    full: "/gallery/full/k016.webp",
    caption: "Performing intricate jaw release therapy",
  },
  {
    id: 17,
    thumb: "/gallery/thumbs/k017.webp",
    full: "/gallery/full/k017.webp",
    caption: "Manual TMJ therapy session",
  },
  {
    id: 18,
    thumb: "/gallery/thumbs/k018.webp",
    full: "/gallery/full/k018.webp",
    caption: "Performing a TMJ assessment",
  },
  {
    id: 19,
    thumb: "/gallery/thumbs/k019.webp",
    full: "/gallery/full/k019.webp",
    caption: "Assessing jaw mobility",
  },
  {
    id: 20,
    thumb: "/gallery/thumbs/k020.webp",
    full: "/gallery/full/k020.webp",
    caption: "Providing relief with facial massage",
  },
  {
    id: 21,
    thumb: "/gallery/thumbs/k021.webp",
    full: "/gallery/full/k021.webp",
    caption: "Providing gentle manual therapy",
  },
  {
    id: 22,
    thumb: "/gallery/thumbs/k022.webp",
    full: "/gallery/full/k022.webp",
    caption: "Putting on laser safety glasses",
  },
  {
    id: 23,
    thumb: "/gallery/thumbs/k023.webp",
    full: "/gallery/full/k023.webp",
    caption: "Performing laser TMJ therapy",
  },
  {
    id: 24,
    thumb: "/gallery/thumbs/k024.webp",
    full: "/gallery/full/k024.webp",
    caption: "Performing laser therapy treatment",
  },
  {
    id: 25,
    thumb: "/gallery/thumbs/k025.webp",
    full: "/gallery/full/k025.webp",
    caption: "Dry needling a patient's jaw",
  },
  {
    id: 26,
    thumb: "/gallery/thumbs/k026.webp",
    full: "/gallery/full/k026.webp",
    caption: "Providing therapeutic neck massage",
  },
  {
    id: 27,
    thumb: "/gallery/thumbs/k027.webp",
    full: "/gallery/full/k027.webp",
    caption: "Providing dry needling therapy",
  },
  {
    id: 28,
    thumb: "/gallery/thumbs/k028.webp",
    full: "/gallery/full/k028.webp",
    caption: "Providing spinal therapy",
  },
  {
    id: 29,
    thumb: "/gallery/thumbs/k029.webp",
    full: "/gallery/full/k029.webp",
    caption: "Krina applying therapeutic tape",
  },
  {
    id: 30,
    thumb: "/gallery/thumbs/k030.webp",
    full: "/gallery/full/k030.webp",
    caption: "Assessing jaw range of motion",
  },
  {
    id: 31,
    thumb: "/gallery/thumbs/k031.webp",
    full: "/gallery/full/k031.webp",
    caption: "Assessing jaw mobility",
  },
  {
    id: 32,
    thumb: "/gallery/thumbs/k032.webp",
    full: "/gallery/full/k032.webp",
    caption: "Performing jaw manipulation technique",
  },
  {
    id: 33,
    thumb: "/gallery/thumbs/k033.webp",
    full: "/gallery/full/k033.webp",
    caption: "Demonstrating jaw anatomy with model",
  },
  {
    id: 34,
    thumb: "/gallery/thumbs/k034.webp",
    full: "/gallery/full/k034.webp",
    caption: "Demonstrating with a jaw model",
  },
  {
    id: 35,
    thumb: "/gallery/thumbs/k035.webp",
    full: "/gallery/full/k035.webp",
    caption: "Demonstrating jaw anatomy with model",
  },
  {
    id: 36,
    thumb: "/gallery/thumbs/k036.webp",
    full: "/gallery/full/k036.webp",
    caption: "Explaining mandibular anatomy",
  },
  {
    id: 37,
    thumb: "/gallery/thumbs/k037.webp",
    full: "/gallery/full/k037.webp",
    caption: "Explaining mandibular anatomy model",
  },
  {
    id: 38,
    thumb: "/gallery/thumbs/k038.webp",
    full: "/gallery/full/k038.webp",
    caption: "Examining a cranial model",
  },
  {
    id: 39,
    thumb: "/gallery/thumbs/k039.webp",
    full: "/gallery/full/k039.webp",
    caption: "Displaying colored cranial bones",
  },
  {
    id: 40,
    thumb: "/gallery/thumbs/k040.webp",
    full: "/gallery/full/k040.webp",
    caption: "Performing targeted facial release",
  },
  {
    id: 41,
    thumb: "/gallery/thumbs/k041.webp",
    full: "/gallery/full/k041.webp",
    caption: "Performing facial acupuncture treatment",
  },
  {
    id: 42,
    thumb: "/gallery/thumbs/k042.webp",
    full: "/gallery/full/k042.webp",
    caption: "Performing facial needling",
  },
  {
    id: 43,
    thumb: "/gallery/thumbs/k043.webp",
    full: "/gallery/full/k043.webp",
    caption: "Explaining treatment plan to patient",
  },
  {
    id: 44,
    thumb: "/gallery/thumbs/k044.webp",
    full: "/gallery/full/k044.webp",
    caption: "Krina holding skull anatomy model",
  },
  {
    id: 45,
    thumb: "/gallery/thumbs/k045.webp",
    full: "/gallery/full/k045.webp",
    caption: "Sketching on a whiteboard",
  },
  {
    id: 46,
    thumb: "/gallery/thumbs/k046.webp",
    full: "/gallery/full/k046.webp",
    caption: "Explaining anatomy to a patient",
  },
  {
    id: 47,
    thumb: "/gallery/thumbs/k047.webp",
    full: "/gallery/full/k047.webp",
    caption: "Krina examining patient's jaw",
  },
  {
    id: 48,
    thumb: "/gallery/thumbs/k048.webp",
    full: "/gallery/full/k048.webp",
    caption: "Assessing jaw mobility",
  },
  {
    id: 49,
    thumb: "/gallery/thumbs/k049.webp",
    full: "/gallery/full/k049.webp",
    caption: "Measuring mouth opening distance",
  },
  {
    id: 50,
    thumb: "/gallery/thumbs/k050.webp",
    full: "/gallery/full/k050.webp",
    caption: "Assessing jaw joint function",
  },
  {
    id: 51,
    thumb: "/gallery/thumbs/k051.webp",
    full: "/gallery/full/k051.webp",
    caption: "Performing laser therapy treatment",
  },
  {
    id: 52,
    thumb: "/gallery/thumbs/k052.webp",
    full: "/gallery/full/k052.webp",
    caption: "Performing targeted laser therapy",
  },
  {
    id: 53,
    thumb: "/gallery/thumbs/k053.webp",
    full: "/gallery/full/k053.webp",
    caption: "Performing acupuncture treatment",
  },
  {
    id: 54,
    thumb: "/gallery/thumbs/k054.webp",
    full: "/gallery/full/k054.webp",
    caption: "Performing facial acupuncture treatment",
  },
  {
    id: 55,
    thumb: "/gallery/thumbs/k055.webp",
    full: "/gallery/full/k055.webp",
    caption: "Guiding a jaw mobility exercise",
  },
  {
    id: 56,
    thumb: "/gallery/thumbs/k056.webp",
    full: "/gallery/full/k056.webp",
    caption: "Patient assessing jaw movement",
  },
  {
    id: 57,
    thumb: "/gallery/thumbs/k057.webp",
    full: "/gallery/full/k057.webp",
    caption: "Assessing neck mobility",
  },
];
